import React, { useEffect, useRef, useState } from "react";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import CloseIcon from "@mui/icons-material/Close";

const PortalV2MultiSelect = ({
  label,
  options = [],
  value = [],
  onChange,
  placeholder = "Select...",
  className = "",
}) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const selectedOptions = options.filter((opt) => value.includes(opt.value));

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleValue = (optValue) => {
    if (value.includes(optValue)) {
      onChange(value.filter((v) => v !== optValue));
    } else {
      onChange([...value, optValue]);
    }
  };

  const clearAll = (e) => {
    e.stopPropagation();
    onChange([]);
  };

  const displayLabel =
    selectedOptions.length === 0
      ? placeholder
      : selectedOptions.length === 1
        ? selectedOptions[0].label
        : `${selectedOptions.length} selected`;

  return (
    <div className={`portal-v2-select-field portal-v2-multi-select ${className}`} ref={rootRef}>
      {label ? <span className="portal-v2-select-field__label">{label}</span> : null}
      <div className={`portal-v2-select portal-v2-select--block ${open ? "is-open" : ""}`}>
        <button
          type="button"
          className="portal-v2-select__trigger portal-v2-select__trigger--block"
          onClick={() => setOpen((prev) => !prev)}
        >
          <span className={`portal-v2-select__value ${!selectedOptions.length ? "is-placeholder" : ""}`}>
            {displayLabel}
          </span>
          <span className="portal-v2-select__trigger-end">
            {selectedOptions.length > 0 && (
              <button type="button" className="portal-v2-select__clear" onClick={clearAll} aria-label="Clear">
                <CloseIcon />
              </button>
            )}
            <KeyboardArrowDownOutlinedIcon className="portal-v2-select__chevron" />
          </span>
        </button>
        {open && (
          <ul className="portal-v2-select__menu portal-v2-select__menu--block" role="listbox">
            {options.map((opt) => (
              <li key={opt.value} role="option" aria-selected={value.includes(opt.value)}>
                <button
                  type="button"
                  className={`portal-v2-select__option portal-v2-multi-select__option ${
                    value.includes(opt.value) ? "is-selected" : ""
                  }`}
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => toggleValue(opt.value)}
                >
                  <span className="portal-v2-multi-select__check">{value.includes(opt.value) ? "✓" : ""}</span>
                  {opt.label}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default PortalV2MultiSelect;
